"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = require("react");
var CheckboxIcon_1 = __importDefault(require("../../../Assets/CustomIcons/CheckboxIcon"));
var CardButton_1 = __importDefault(require("../../Atoms/CardButton/CardButton"));
var Text_1 = __importDefault(require("../../Atoms/Text"));
var TextField_1 = __importDefault(require("../TextField/TextField"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var browserAndDeviceDetection_1 = require("../../../Helpers/browserAndDeviceDetection");
var deviceSpecificHandlers_1 = require("../../../Helpers/deviceSpecificHandlers");
var makeCheckBoxStyling_1 = __importStar(require("./makeCheckBoxStyling"));
var CheckBox = function (_a) {
    var showText = _a.showText, Icon = _a.Icon, id = _a.id, isOtherOption = _a.isOtherOption, onClick = _a.onClick, onChange = _a.onChange, onKeyDown = _a.onKeyDown, otherInputError = _a.otherInputError, otherInputValue = _a.otherInputValue, selected = _a.selected, text = _a.text, subtext = _a.subtext, textAlign = _a.textAlign, experimentName = _a.experimentName, hideCheckbox = _a.hideCheckbox, disabled = _a.disabled, smallIcon = _a.smallIcon, minHeight = _a.minHeight;
    var _b = (0, react_1.useState)(selected), isSelected = _b[0], setIsSelected = _b[1];
    var _c = (0, react_1.useState)(false), isFocused = _c[0], setIsFocused = _c[1];
    var _d = (0, react_1.useState)(otherInputValue), otherValue = _d[0], setOtherValue = _d[1];
    var styles = (0, makeCheckBoxStyling_1.default)(smallIcon, minHeight);
    var otherInputRef = (0, react_1.useRef)(null);
    var isIconPresent = !!Icon;
    var isOtherInputPresent = (isOtherOption && isFocused) || !!otherValue;
    var textAlignBasedOnCheckbox = hideCheckbox ? 'center' : textAlign;
    var handleBlur = function (event) {
        if (event) {
            event.stopPropagation();
        }
        if (!isSelected) {
            setIsFocused(false);
            if (!otherValue) {
                setIsSelected(false);
            }
        }
        if (isSelected && isFocused && !otherValue) {
            setTimeout(function () {
                setIsSelected(false);
                setIsFocused(false);
            }, 100);
        }
    };
    var handleClick = function () {
        onClick({ id: id, selected: !selected });
        if (!isSelected && (0, browserAndDeviceDetection_1.isIOS)() && isOtherOption) {
            (0, deviceSpecificHandlers_1.iosFocusHandler)(otherInputRef);
        }
        setIsSelected(!isSelected);
        setIsFocused(true);
    };
    var handleInputClick = function (e) {
        var _a;
        e.stopPropagation();
        (_a = otherInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setIsSelected(true);
        onClick({ id: id, selected: true });
    };
    var handleKeyDown = function (event) {
        if (event) {
            onKeyDown(event);
            if (event.key === 'Enter' && otherInputRef.current) {
                if (!otherValue) {
                    setIsSelected(false);
                    setIsFocused(false);
                }
                otherInputRef.current.blur();
            }
        }
    };
    var onOtherTextFieldChange = function (inputChangeEvent) {
        onChange(inputChangeEvent);
        setOtherValue(inputChangeEvent.value);
        setIsSelected(!!inputChangeEvent.value);
    };
    (0, react_1.useEffect)(function () {
        if (isSelected && otherInputRef.current) {
            otherInputRef.current.focus();
        }
    }, [isSelected]);
    var renderOtherInput = function () { return ((0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, css: styles.textGrid, children: (0, jsx_runtime_1.jsx)(Box_1.default, { css: styles.otherInput, marginRight: isIconPresent ? '45px' : '1.2rem', children: (0, jsx_runtime_1.jsx)(TextField_1.default, { "data-testid": "otherInputTextfield:".concat(id), id: id, placeholder: text, onClick: handleInputClick, onChange: onOtherTextFieldChange, isOtherOption: true, inputRef: otherInputRef, errorMessage: otherInputError ? '' : undefined, value: otherInputValue, experimentName: experimentName, disabled: hideCheckbox }) }) })); };
    var renderTextContent = function () { return ((0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, css: styles.textGrid, "data-testid": "".concat(textAlign, "Text:").concat(id), children: (0, jsx_runtime_1.jsx)(Box_1.default, { children: subtext ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, { variant: "listItemWithSubtext", align: textAlignBasedOnCheckbox, experimentName: experimentName, children: text }), (0, jsx_runtime_1.jsx)(Text_1.default, { variant: "listItemSubtext", align: textAlignBasedOnCheckbox, experimentName: experimentName, children: subtext })] })) : ((0, jsx_runtime_1.jsx)(Text_1.default, { variant: "listItem", align: textAlignBasedOnCheckbox, experimentName: experimentName, children: text })) }) })); };
    var renderIcon = function (location) { return ((0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, css: location === 'center' ? styles.centerIcon : styles.leftIcon, children: (0, jsx_runtime_1.jsx)("div", { css: styles.imgDiv, "data-testid": "".concat(location, "CheckboxIcon"), children: Icon }) })); };
    var renderCheckbox = function (location) { return ((0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, css: location === 'right' && styles.checkboxContainerRight, children: !hideCheckbox && ((0, jsx_runtime_1.jsx)(Checkbox_1.default, { id: "checkbox-".concat(id), css: location === 'left' && styles.checkbox, checked: isSelected, onClick: function (event) { return event.preventDefault(); }, color: "primary", "data-testid": "".concat(location, "Checkbox:").concat(id), icon: (0, jsx_runtime_1.jsx)(CheckboxIcon_1.default, { isChecked: false }), checkedIcon: (0, jsx_runtime_1.jsx)(CheckboxIcon_1.default, { isChecked: true }), onMouseDown: function (event) { return event.preventDefault(); }, disabled: disabled })) })); };
    var renderRightPlaceholder = function () {
        return ((0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, css: (0, makeCheckBoxStyling_1.getPlaceholderStyles)(textAlign === 'center', isIconPresent) }));
    };
    return ((0, jsx_runtime_1.jsx)(CardButton_1.default, { selected: isSelected, "data-selected": isSelected, onClick: handleClick, onKeyDown: handleKeyDown, "data-testid": "checkboxCardButton", outlined: isSelected, onBlur: handleBlur, experimentName: experimentName, disabled: disabled, children: (0, jsx_runtime_1.jsxs)(Grid_1.default, { container: true, css: styles.grid, justifyContent: "flex-start", alignItems: "center", wrap: "nowrap", children: [(0, jsx_runtime_1.jsx)(Grid_1.default, { container: true, alignItems: "center", css: styles.innerGrid, children: showText ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isIconPresent ? renderIcon('left') : renderCheckbox('left'), isOtherInputPresent ? renderOtherInput() : renderTextContent(), (textAlign === 'center' || isIconPresent) &&
                                renderRightPlaceholder()] })) : (renderIcon('center')) }), isIconPresent && isSelected && renderCheckbox('right')] }) }));
};
CheckBox.defaultProps = defaultProps_1.default;
exports.default = CheckBox;
//# sourceMappingURL=CheckBox.js.map